import {
    Component,
    OnInit,
    Output,
    EventEmitter,
    ViewChild,
} from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";

import {
    ChartComponent,
    ApexAxisChartSeries,
    ApexChart,
    ApexXAxis,
    ApexTitleSubtitle,
    ApexNonAxisChartSeries,
    ApexResponsive,
} from "ng-apexcharts";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";

export type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    xaxis: ApexXAxis;
};

export type DonutChartOptions = {
    series: ApexNonAxisChartSeries;
    chart: ApexChart;
    responsive: ApexResponsive[];
    labels: any;
};

@Component({
    selector: "app-supplier-home",
    templateUrl: "./supplier-home.component.html",
    styleUrls: ["./supplier-home.component.scss"],
})
export class SupplierHomeComponent implements OnInit {
    displayName: any;
    responseData: any;
    stats: any;
    statsInternal: any;
    chartDataPo = false;
    chartDataInvoice = false;
    sessionExpired = false;
    isError = false;
    errorMsg = "";
    public chartOptions: Partial<ChartOptions> | any;
    public donutChartOptions: Partial<DonutChartOptions> | any;
    data = false;
    loading = true;
    refreshInternalAnalytics = false;
    refreshPo = false;
    refreshAnalytics = false;
    openMobileMenu: boolean = false;
    username = "";
    isCondensed: boolean = false;
    internalError = false;
    externalError = false;
    // currentLayout = {
    //     isCondensed: true,
    // };
    onboardingStatus: any;
    pwChangeMsg = "";
    onboardingSucessMsg = "";
    passwordSet: any;
    onboadingSet: any;

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private router: Router
    ) {}

    // toggleSidebar() {
    //     this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    //     document.body.setAttribute(
    //         "data-sidebar-size",
    //         this.currentLayout.isCondensed ? "condensed" : "default"
    //     );
    // }

    accountLogout() {
        const userData = {
            session: { sessionId: localStorage.getItem("userSession") },
        };
        this.authService.logOut(userData).subscribe(
            (res) => {
                const responseData: any = res;
                if (responseData.status === "ok") {
                    localStorage.clear();
                    this.router.navigateByUrl("/");
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }

    refreshInternalStats() {
        this.refreshInternalAnalytics = true;
        const userData = {
            action: "list",
            email: "",
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("userSession") },
        };

        this.authService.fetchAnalytics(userData).subscribe(
            (res) => {
                this.loading = false;
                this.refreshInternalAnalytics = false;
                this.responseData = res;
                if (
                    this.responseData.status === "successful" ||
                    this.responseData.analytics.length !== 0
                ) {
                    this.statsInternal = this.responseData.analytics;
                    if (
                        this.statsInternal.approved_invoices_number === 0 &&
                        this.statsInternal.inProcesses_invoices_number === 0 &&
                        this.statsInternal.paid_invoices_number === 0 &&
                        this.statsInternal.total_rejected_invoice_number === 0
                    ) {
                        this.chartDataInvoice = false;
                    } else {
                        this.chartDataInvoice = true;
                    }

                    if (
                        this.statsInternal.fully_invoiced_po_number === 0 &&
                        this.statsInternal.non_invoiced_po_number === 0 &&
                        this.statsInternal.partially_invoiced_po_number === 0
                    ) {
                        this.chartDataPo = false;
                    } else {
                        this.chartDataPo = true;
                    }

                    this.donutChartOptions = {
                        series: [
                            this.statsInternal.fully_invoiced_po_number,
                            this.statsInternal.partially_invoiced_po_number,
                            this.statsInternal.non_invoiced_po_number,
                        ],

                        chart: {
                            height: 295,
                            type: "donut",
                        },
                        colors: ["#18479f", "#a3a1fb", "#9acce4"],
                        labels: [
                            "Fully Invoiced POs",
                            "Partially Invoiced POs",
                            "Non-Invoiced POs",
                        ],
                        legend: {
                            show: true,
                            position: "bottom",
                        },
                        dataLabels: {
                            enabled: true,
                            formatter: function (val: any, opts: any) {
                                return opts.w.config.series[opts.seriesIndex];
                            },
                        },
                        tooltip: {
                            enabled: true,
                            custom: function ({ series, seriesIndex, w }) {
                                let text = "";

                                if (
                                    w.globals.labels[seriesIndex] ===
                                    "Fully Invoiced POs"
                                ) {
                                    text =
                                        "Complete PO consumed and Invoices Submitted.";
                                } else if (
                                    w.globals.labels[seriesIndex] ===
                                    "Partially Invoiced POs"
                                ) {
                                    text =
                                        "Partial PO Value consumed and Invoices submitted.";
                                } else {
                                    text =
                                        "No invoice submitted against these POs.";
                                }

                                return (
                                    '<div class="arrow_box">' +
                                    "<span>" +
                                    text +
                                    "</span>" +
                                    "</div>"
                                );
                            },
                        },
                    };

                    this.chartOptions = {
                        series: [
                            {
                                name: "Invoices",
                                data: [
                                    {
                                        x: "Invoices posted and ready for payment",
                                        y: this.statsInternal
                                            .approved_invoices_number,
                                    },
                                    {
                                        x: "Invoices received and are in processing at JSW",
                                        y: this.statsInternal
                                            .inProcesses_invoices_number,
                                    },
                                    {
                                        x: "Invoices Paid",
                                        y: this.statsInternal
                                            .paid_invoices_number,
                                    },
                                    {
                                        x: "Invoices Rejected",
                                        y: this.statsInternal
                                            .total_rejected_invoice_number,
                                    },
                                ],
                            },
                        ],
                        chart: {
                            height: 250,
                            type: "bar",
                        },
                        plotOptions: {
                            bar: {
                                distributed: true,
                            },
                        },
                        legend: {
                            show: true,
                            position: "bottom",
                        },
                        colors: ["#18479f", "#a3a1fb", "#18c984", "#ff1f3e"],
                        xaxis: {
                            type: "category",
                            categories: [
                                "Processed Invoices",
                                "Invoices in Process",
                                "Paid Invoices",
                                "Rejected Invoices",
                            ],
                            labels: {
                                show: false,
                            },
                            tooltip: {
                                enabled: false,
                            },
                        },
                        yaxis: {
                            show: true,
                            tooltip: {
                                enabled: true,
                            },
                        },
                        tooltip: {
                            fixed: {
                                enabled: true,
                                position: "topRight",
                                offsetX: 0,
                                offsetY: 0,
                            },
                            custom: function ({
                                series,
                                seriesIndex,
                                dataPointIndex,
                                w,
                            }) {
                                return (
                                    '<div class="arrow_box">' +
                                    "<span>" +
                                    w.globals.seriesX[seriesIndex][
                                        dataPointIndex
                                    ] +
                                    "</span>" +
                                    "</div>"
                                );
                            },
                        },
                    };
                } else {
                    this.loading = false;
                    this.isError = true;
                    this.internalError = true;
                    this.data = false;
                    this.chartDataInvoice = false;
                    this.chartDataPo = false;
                }
            },
            (error) => {
                console.log(error);
                console.log("The Error");
                this.loading = false;
                this.internalError = true;
                this.chartDataInvoice = false;
                if (error.status === 401) {
                    this.sessionExpired = true;
                    this.errorMsg = error.error.msg;
                }
            }
        );
    }

    refreshExternalStats() {
        this.refreshAnalytics = true;
        const userData = {
            action: "list",
            email: "",
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("userSession") },
        };
        this.authService.fetchExternalAnalytics(userData).subscribe(
            (res) => {
                this.loading = false;
                this.refreshAnalytics = false;
                this.responseData = res;
                if (
                    this.responseData.status === "successful" ||
                    this.responseData.analytics.length !== 0
                ) {
                    this.stats = this.responseData.analytics;
                } else {
                    console.log("Error here");
                    this.loading = false;
                    this.externalError = true;
                    this.isError = true;
                    this.data = false;
                    this.refreshAnalytics = true;
                }
            },
            (error) => {
                console.log(error);
                console.log("The Error");
                this.refreshAnalytics = false;
                this.externalError = true;
                this.loading = false;
                this.isError = true;
                if (error.status === 401) {
                    this.sessionExpired = true;
                    this.errorMsg = error.error.msg;
                }
            }
        );
    }

    ngOnInit(): void {
        this.loading = true;
        this.displayName = localStorage.getItem("displayName");

        this.onboardingStatus = this.authService.getOnboardingStatus();
        this.pwChangeMsg = "Password changed successfully.";
        this.onboardingSucessMsg = "Account activated successfully.";

        this.passwordSet = true;
        this.onboadingSet = false;

        setTimeout(() => {
            this.passwordSet = false;
            this.onboadingSet = true;
        }, 4000);

        setTimeout(() => {
            this.onboardingStatus = false;
        }, 8000);

        //console.log(this.onboardingStatus);

        const userData = {
            action: "list",
            email: "",
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("userSession") },
        };

        this.refreshInternalStats();
        this.refreshExternalStats();
    }
}
